export enum ResultType {
    PartCase = "Part Case",
    WholeCase = "Whole Case",
    Range = "Range",
    PackingBox = "PackingBox",
    OuterCUbe = "OuterCUbe",
}